import React, { useEffect } from 'react';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

export default function Toast({ show, message, type = 'success', onClose }) {
    useEffect(() => {
        if (!show) return;
        const timer = setTimeout(() => {
            onClose();
        }, 3000);
        return () => clearTimeout(timer);
    }, [show, onClose]);

    if (!show) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '24px',
            right: '24px',
            background: 'var(--bg-surface, white)',
            border: '1px solid var(--border, #ccc)',
            borderRadius: '12px',
            padding: '14px 18px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            boxShadow: 'var(--shadow-lg, 0 10px 25px rgba(0,0,0,0.15))',
            zIndex: 9999,
            minWidth: '280px',
            color: 'var(--text-primary, black)',
            animation: 'slideInRight 0.3s ease'
        }}>
            <ObliqueIcon 
                name={type === 'success' ? 'check_circle' : 'error'} 
                size={18} 
                className={type === 'success' ? 'text-emerald-500' : 'text-rose-500'} 
            />
            <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', fontSize: '13px' }}>
                    {message}
                </div>
            </div>
            <button 
                onClick={onClose}
                style={{
                    background: 'transparent', border: 'none', cursor: 'pointer',
                    color: 'var(--text-tertiary, #999)', padding: '4px',
                    display: 'flex', alignItems: 'center'
                }}
            >
                <ObliqueIcon name="close" size={14} />
            </button>
        </div>
    );
}
